export const ClearGrabCommand = 'clearGrabCommand'
export const StartSingleGrabCommand = 'startSingleGrabCommand'
export const StopGrabCommand = 'stopGrabCommand'
export const HighlightRectangleCommand = 'highlightRectangleCommand'
export const GetCurrentPageCommand = 'getCurrentPageCommand'
export const SetPdfRotationCommand = 'setPdfRotationCommand'
export const GetPagesInBetweenCommand = 'getPagesInBetweenCommand'